import { exampleOwnershipGroup, OwnershipGroup } from './OwnershipGroup';

export interface PaginatedOwnershipGroupResponse {
  ownershipGroups: OwnershipGroup[];
  page: number;
  count: number;
}

export const examplePaginatedOwnershipGroupResponse: PaginatedOwnershipGroupResponse = {
  ownershipGroups: [exampleOwnershipGroup],
  page: 1,
  count: 1,
};
